  import {fetchData, postData} from "../Data/fetch";
  import {ApplicationDispatch, SET_SERVER_MESSAGE} from "../store/application/types";
  import type { IConfiguration } from "../Data/ConfigurationData";
  import { FeatureFlagIds } from "./featureFlagIds";
  
  interface FinicityStatus {
    primaryStatus: string;
    coApp1Status: string;
    coApp2Status: string;
    primaryStatusDate: Date;
    coApp1StatusDate: Date;
    coApp2StatusDate: Date;
  }  
    
  export const getCurrentFincityStatus = async (
    applicationId: string, 
    dispatch: ApplicationDispatch
  ) : Promise<{status: FinicityStatus}>=> {
      const url = `api/finicity/finicitystatus/${applicationId}`
      const response = await fetchData(url, dispatch);
    return response as {status: FinicityStatus};
  };
    
  /**
   * Whether this client uses Finicity bank/income verification (FinicityEnabled feature flag). Off unless the flag is
   * explicitly on, so a client with no configuration never polls Finicity status or documents or shows its buttons.
   */
  export const isFinicityEnabled = (configuration: IConfiguration | undefined): boolean =>
    configuration?.featureFlags?.[FeatureFlagIds.FinicityEnabled] === true;
